import { useParams } from "react-router-dom";

type AccountRouteParams = Partial<Record<"username" | "statusId", string>>;

const useAccountRouteParams = (): Readonly<AccountRouteParams> => {
  const params = useParams<"username" | "statusId">();
  const { username } = params;
  // Account routes match `/:username` (since v6 cannot match `/@:username` as
  // a param). Strip the leading "@" so leaf components receive the bare handle.
  if (typeof username === "string" && username.startsWith("@")) {
    return { ...params, username: username.slice(1) };
  }

  return params;
};

export { useAccountRouteParams };
